import { Component, Input, OnChanges, OnInit, SimpleChanges,  OnDestroy } from '@angular/core';
import { Offerpack } from '@app/models/offerpack/Offerpack';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { ExportService } from '@app/services/export.service';
import { Partner } from '@app/models/partner/IPartner';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TrafficsService } from '@app/services/traffics.service';
import { AcvisService } from '@app/services/acvis.service';
import { OfferpackService } from '@app/services/offerpack.service';
import { Customer } from '../../../models/customers/Customer';
import { AuthService } from '@app/services/auth.service';

@Component({
    selector: 'app-offerpdf',
    templateUrl: './offerpdf.component.html',
    styleUrls: ['./offerpdf.component.scss'],
    standalone: false
})
export class OfferpdfComponent implements OnInit, OnChanges, OnDestroy {
    @Input() offerpack: Offerpack;
    private unsubscribe$ = new Subject();
    currentCustomer: Customer;
    header = [];
    partner: Partner;
    loading: boolean = false;
    constructor (
        private exportService: ExportService,
        private guardService: AuthGuardService,
        private router: Router,
        private trafficsService: TrafficsService,
        private acvisService: AcvisService,
        private offerpackService: OfferpackService,
        private authService: AuthService
    ) { }

    ngOnInit (): void {
        this.authService.auth$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((customer: Customer) => {
            this.currentCustomer = customer;
            this.partner = this.guardService.getPartner();
        });
    }

    ngOnChanges (changes: SimpleChanges) {
        if (changes['offerpack']) {
            this.offerpack = changes['offerpack'].currentValue;
            // console.log(this.offerpack);
        }
    }

    
    ngOnDestroy (): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    async exportasPdf () {
        this.loading = true;
        const url = this.router.serializeUrl(
            this.router.createUrlTree(['offerpack', this.offerpack.packid], {})
        );
        const imgurl = this.offerpack?.partner?.avatar?.length > 0 ? this.offerpack.partner.avatar : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=';
        this.header = [
            {
                table: {
                    widths: ['100%'],
                    body: [
                        [
                            {
                                alignment: 'left',
                                margin: [0, 10],
                                border: [false, false, false, false],
                                stack: [
                                    {
                                        text: 'Sehr geehrte Kunde,\n\n\nvielen Dank für Ihren Besuch in unserem Reisebüro!\n\n\nDie Angebote können sie sich nach dem abscannen des QR code’s ansehen:\n ',
                                        fontSize: 11,
                                    },
                                    {
                                        qr: window.location.origin + url,
                                        fit: '100'
                                    },
                                    {
                                        text: '(Online version)',
                                        link: window.location.origin + url,
                                        margin: [0, 10],
                                        fontSize: 11
                                    },
                                    {
                                        text: `\nBitte beachten Sie, dass es sich um tagesaktuelle Angebote handelt. Preise sowie Vakanzen können sich jederzeit verändern.
                                        \nSollten Sie weitere Fragen oder Änderungswünsche hierzu haben, dürfen Sie uns gerne jederzeit kontaktieren.
                                        \nSicherlich konnten wir Ihnen mit diesen Informationen weiterhelfen und würden uns freuen, wenn das passende Angebot für Sie dabei ist.
                                        \nAuf diesem Weg wünschen wir Ihnen einen schönen Tag und viel Freude beim Träumen von Ihrem kommenden Urlaub!
                                        \nBei Fragen stehen wir Ihnen gerne zu unseren Service Zeiten zur Verfügung!
                                        \n\nHerzliche Grüße`,
                                        fontSize: 11,
                                    }
                                ]
                            }
                        ]
                    ]
                }
            },
            {
                table: {
                    widths: ['100%'],
                    body: [
                        [
                            {
                                alignment: 'left',
                                border: [false, false, false, false],
                                stack: [
                                    {
                                        image: imgurl,
                                        width: 50,
                                    },
                                    {
                                        text: this.offerpack?.partner?.firstname + ' ' + this.offerpack?.partner?.lastname,
                                        margin: [0, 10, 0, 0],
                                        bold: true,
                                        fontSize: 12
                                    },
                                    {
                                        text: this.offerpack?.partner?.salutation === 'Herr' ? 'Reiseberater' : 'Reiseberaterin',
                                        fontSize: 11,
                                        margin: [0, 10, 0, 0],
                                    },
                                    {
                                        text: this.offerpack?.partner?.tel?.length > 0 ? 'Tel: ' + this.offerpack.partner.tel : 'Tel: ' + this.partner.tel,
                                        margin: [0, 5, 0, 0],
                                        fontSize: 11
                                    },
                                    {
                                        margin: [0, 5, 0, 0],
                                        text: [
                                            'E-Mail: ',
                                            {
                                                text: this.offerpack?.partner?.email,
                                                style: {
                                                    fontSize: 11,
                                                    color: 'blue',
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        margin: [0, 10, 0, 0],
                                        text: [
                                            'Partner: ',
                                            {
                                                text: this.offerpack?.partner?.partnerid,
                                                link: window.location.origin,
                                                style: {
                                                    fontSize: 11,
                                                    color: 'blue',
                                                }
                                            }
                                        ],
                                        fontSize: 11
                                    },
                                    {
                                        qr: window.location.origin,
                                        margin: [0, 5, 0, 0],
                                        fit: '50'
                                    },
                                    {
                                        text: '(Partner site)',
                                        link: window.location.origin,
                                        margin: [0, 5],
                                        fontSize: 10
                                    }
                                ]
                            }
                        ]
                    ]
                }
            },
        ];
        /* for (let i = 0; i < this.offerpack.packlist.length; i++) {
            if (this.offerpack.packlist[i].type === 'traffics') {
                let pack = await this.getTraffics(this.offerpack.packlist[i].offerid);
                pack = await this.getGiataMedia(pack);
                await this.setInContentTraffics(pack, (i + 1));
                console.log(pack)
            }
        } */
        this.loading = false;
        this.exportService.exportOffers(this.header);
    }

    async setInContentTraffics (pack, i) {
        let img = await this.getBase64ImageFromUrl(pack?.catalogData?.imageList[0]);

        if (!img && pack?.catalogData?.imageList?.length > 1) {
            img = await this.getBase64ImageFromUrl(pack?.catalogData?.imageList[1]);
        }

        if (!img && pack?.catalogData?.imageList?.length > 2) {
            img = await this.getBase64ImageFromUrl(pack?.catalogData?.imageList[2]);
        }

        if (!img) {
            img = await this.getBase64ImageFromUrl('https://suntour-reisen.de/assets/images/empty.jpg');
        }

        this.header.push(
            {
                margin: [0, 20, 0, 8],
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                border: [false, false, false, false],
                                fillColor: '#edf2f5',
                                style: 'offerheader',
                                text: 'Angebot Nr. ' + i
                            }
                        ]
                    ]
                }
            },
            {
                columns: [
                    {
                        stack: [
                            {
                                image: img,
                                width: 130,
                            }
                        ]
                    }
                ]
            }
        );
    }

    async getBase64ImageFromUrl (imageUrl) {
        return new Promise((resolve) => {
            this.offerpackService.request({ url: imageUrl }, 'base64', this.currentCustomer?.token).pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe(data => {
                resolve(data?.base64);
            });
        });
    }

    async getTraffics (packid): Promise<any> {
        return new Promise(resolve => {
            this.trafficsService.request({ offerid: packid, partnerid: this.partner.parentid }, 'offers/getoffersbycode').pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe(data => {
                resolve(data);
            });
        });
    }

    async getGiataMedia (booking): Promise<any> {
        return new Promise(resolve => {
            if (booking?.extra?.orderId?.length > 0) {
                this.acvisService.request({ id: booking.extra.orderId }, 'sktvorderdata').pipe(
                    takeUntil(this.unsubscribe$)
                ).subscribe((res) => {
                    if (res && !res.error) {
                        booking.categoryAr = res?.categoryAr?.length > 0 ? res.categoryAr : [];
                        booking.images = res?.images?.length > 0 ? res?.images : [];
                    }
                    resolve(booking);
                });
            } else if (booking.commonOffer?.hotelOffer?.hotel?.giata?.hotelId?.length > 0) {
                this.trafficsService.request({ giataId: booking.commonOffer.hotelOffer.hotel.giata.hotelId, tourOperatorList: booking.commonOffer?.hotelOffer?.hotel?.tourOperator?.code }, '/hotels/giataId').pipe(
                    takeUntil(this.unsubscribe$)
                ).subscribe((res) => {
                    booking.mediaData = res?.hotel?.mediaData;
                    booking.location = res?.hotel?.location;
                    booking.catalogData = res?.hotel?.catalogData;
                    booking.categoryAr = [];
                    const catg = Number(String(res?.hotel?.category).replace(/,/g, '.'));
                    for (let i = 0; i < Math.floor(catg); i++) {
                        booking.categoryAr.push(1);
                    }
                    if (catg > Math.floor(catg)) {
                        booking.categoryAr.push(0.5);
                    }
                    for (let i = 0; i < booking?.catalogData?.imageList?.length; i++) {
                        booking.catalogData.imageList[i] = String(booking?.catalogData.imageList[i]).replace('http://', 'https://');
                    }
                    resolve(booking);
                });
            } else {
                resolve(null);
            }
        });
    }
}
